import { Component, OnInit, TemplateRef, ChangeDetectorRef, AfterViewInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global"; 
import { HttpClient, HttpParams } from "@angular/common/http";
import { DatePipe } from "@angular/common" 
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import * as CONSTANT from "../../../services/constants"
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge"
import { ExcelService } from "src/app/services/excel.service";
// import * as moment from 'moment';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
@Component({
  selector: "app-serach-report",
  templateUrl: "./serach-report.component.html",
  styleUrls: ["./serach-report.component.css"]
})
export class SerachReportComponent implements OnInit, AfterViewInit {
  Highcharts: typeof Highcharts = Highcharts;
  public userDatas: any;
  allData:any;
 
  searchConductByMonthLable : any = []
  searchConductByMonthValue : any = [] 
  top6SearchesByUsers : any = []
  
  color= ["#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#517595","#935A91","#D8905E","#4D7DAD","#51ACAC",]

  currentPage=1;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  maxDate: Date;
  today: Date;
  invalidDateFilter = false;
  fromDate: any;
  toDate: any;
  show = 0;
  filterForm: FormGroup;
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  showError = false;
  noDataFound = false;

  constructor( public route: ActivatedRoute,  private router: Router, private api: AdminService, public datePipe: DatePipe, private formBuilder: FormBuilder,private modalService: BsModalService, private ref:ChangeDetectorRef,private excelService:ExcelService) {  
    this.filterForm = this.formBuilder.group({
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
    });
    this.today = new Date();
    this.maxDate = new Date(this.today.getDate() + 3);
  }
  ngAfterViewInit(): void {
    // this.createChartColumn();
    // setTimeout(() => {
    //   this.createChartColumn();
    // }, 2000);
    // this.ref.detectChanges()
  }
  ngOnInit(): void {
    this.getDashboard(); 
    // setTimeout(() => {
    //   this.createChartColumn();
    // }, 2000);
    // this.ref.detectChanges()
  }
  getDashboard(){
    let params = new HttpParams();
    params = params.append("skip",  this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._searchDetail,params)
    .subscribe(async (res) => { 
      this.searchConductByMonthLable = []
      this.searchConductByMonthValue = []
      this.top6SearchesByUsers = []
      this.pagination.totalItems = res.data.totalCount; 
      this.allData = res.data;  
      this.noDataFound = true; 
      for (let inventory of this.allData.searchConductByMonth) {
        if(inventory.count > 0){
          this.noDataFound = false
        }
        this.searchConductByMonthLable.push(inventory.month);
        this.searchConductByMonthValue.push(inventory.count);
      } 
      if(this.allData.top6SearchesByUsers.length == null || this.allData.top6SearchesByUsers.length > 0){
        this.noDataFound = true
      }
      for (let data of this.allData.top6SearchesByUsers) {
        if(data.count > 0){
          this.noDataFound = false
        }
        this.top6SearchesByUsers.push({
          name: data.recruiter?.name,
          y: data.count,
        });
      }
      this.createChartColumn();
      this.ref.detectChanges()
    })
  } 
     
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getDashboard();
  }
  // hightchart 
 
  private createChartColumn(): void { 
    const chart= Highcharts.chart("chart-column" as any, {
      color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
      chart: {
        type: "column"
      },
      title: {
        text: ""
      },
      xAxis: {
        type: "category",
        categories: this.searchConductByMonthLable,
      },
      yAxis: {
        min: 0,
        title: "",
        labels: {
          overflow: "justify"
        }
      }, 
      plotOptions: {
        column: {
          colorByPoint: true,
          dataLabels: {
            enabled: true
          }
        }
      },
      legend: {
        enable: false
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: "Searches conducted",
          data: this.searchConductByMonthValue}
      ]
    
      } as any);
    const chart1 = Highcharts.chart("bar-Horizontal" as any, {
      
    color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
    chart: {
      type: "bar"
    },
    title: {
      text: ""
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      min: 0,
      title: "",
      labels: {
        overflow: "justify"
      }
    }, 
    plotOptions: {
      bar: {
        colorByPoint: true,
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      enable: false
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Searches conducted by recruiter",
        type: "bar",
        barWidth: "60%",
        data: this.top6SearchesByUsers,}
    ]
  
    } as any); 
  }

  openModal(template: TemplateRef<any>) {
    this.modalService.show(template);
  }
  close() {
    this.modalRef?.hide();
  }
  
  applyFilter(modal: any) {
    this.fromDate = this.datePipe.transform(
      this.filterForm.value.startDate,
      "yyyy-MM-dd"
    );
    this.toDate = this.datePipe.transform(
      this.filterForm.value.endDate,
      "yyyy-MM-dd"
    );
    if (this.filterForm.valid) {
      if (this.fromDate && this.toDate) {
        if (this.fromDate > this.toDate) {
          this.invalidDateFilter = true;
          setTimeout(() => {
            this.invalidDateFilter = false;
          }, 4000);
          return;
        }
      }
      this.getDashboard();
      this.show = 1;
      this.modalService.hide();
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
      return;
    }
  }

  clearFilter(modal: any) {
    this.filterForm.reset();
    this.fromDate = "";
    this.toDate = "";
    this.show = 0;
    this.modalRef?.hide();
    this.modalService.hide();
    this.getDashboard();
  }
  
  // download Csv file
  downloadCsv(){
    let excelData: any;  
    let dataToSend:any = []
    let allData:any = [] 
    let params = new HttpParams(); 
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._searchDetail,params)
    .subscribe(async (res) => {
     let allData = res.data.list; 
     allData.map(val=>{
      const data = {
        SearchName: val?.title,
        SearchedOn: val?.createdAt,
        // SearchedOn: moment(val?.createdAt).format('MMM DD, YYYY'),
        MatchedCandidates: val?.resultCount,
        userEmail: val?.recruiter?.email,
        userName: val?.recruiter?.name,
      }
      dataToSend.push(data)
    })
    excelData = dataToSend;
   this.excelService.exportAsExcelFile(excelData, "Searches by keywords");
    });
   
  }
}
